import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { UserType } from "models/UserType";
import { tUserRole } from "i18n/enums";

interface ReportsSliceState {
  searchKeyword: string;
  selectedRole: UserType;
  reportId: number;
  pageNumberSearch: number;
  isFirstSearch: boolean;
  hasReports: boolean;
  newMessagesCounter: number;
}

const initialState = {
  searchKeyword: "",
  selectedRole: { value: 1, label: tUserRole(1) },
  reportId: null,
  pageNumberSearch: 1,
  isFirstSearch: true,
  hasReports: false,
  newMessagesCounter: 0,
} as ReportsSliceState;

const reportsSlice = createSlice({
  name: "reportsData",
  initialState,
  reducers: {
    setSearchKeyword(state, action: PayloadAction<string>) {
      state.searchKeyword = action.payload;
      if (action.payload !== "") {
        if (state.isFirstSearch) {
          state.isFirstSearch = false;
          state.pageNumberSearch = 1;
        }
      } else state.isFirstSearch = true;
    },
    setselectedRole(state, action: PayloadAction<UserType>) {
      state.selectedRole = action.payload;
      localStorage.setItem("selectedRole", JSON.stringify(action.payload));
    },
    setReportId(state, action: PayloadAction<number>) {
      state.reportId = action.payload;
    },
    setPageNumberSearch(state, action: PayloadAction<number>) {
      state.pageNumberSearch = action.payload;
    },
    setHasReports(state, action: PayloadAction<boolean>) {
      state.hasReports = action.payload;
    },
    setUnreadMessagesCounter(state, action: PayloadAction<number>) {
      state.newMessagesCounter = action.payload;
    },
  },
});

export const {
  setSearchKeyword,
  setselectedRole,
  setReportId,
  setPageNumberSearch,
  setHasReports,
  setUnreadMessagesCounter,
} = reportsSlice.actions;
export default reportsSlice.reducer;
